import { NgForOf } from '@angular/common';
import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { AdminService } from '../../../admin/admin.service';
import { DataToolsLiteMessage } from '../../../shared/DataToolsLiteMessage';
import { DatatoolsLiteService } from '../../../shared/services/datatools-lite.service';
import { DataToolsSettingsService } from '../../data-tools-settings.service';
import {WeightService} from '../weight.service';
import {IBullhornFieldAndLabel, IModelReference} from '../weights-interfaces';

@Component({
  selector: 'app-weight-field',
  templateUrl: './weight-field.component.html',
  imports: [
    MatSelect,
    FormsModule,
    MatOption,
    NgForOf
  ],
  styleUrls: ['./weight-field.component.scss']
})
export class WeightFieldComponent implements OnInit, AfterViewInit {
  @Input() reference: IModelReference;
  selected;
  options: IBullhornFieldAndLabel[];

  constructor(
    public weightService: WeightService,
    public adminService: AdminService,
    public datatoolsLiteService: DatatoolsLiteService,
    public dataToolsSettingsService: DataToolsSettingsService
  ) { }

  ngOnInit() {
    this.options = this.weightService.availableBHOptions[this.reference.entity];
    this.options.sort((a, b) => a.fieldLabel.localeCompare(b.fieldLabel));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const selection = this.weightService.customWeightSelection[this.reference.entity];

      this.selected = selection[this.reference.weightField];

      console.log(this.selected);
    }, 10);
  }

  change(selected: any) {
    if (this.adminService.isInLiteMode()) {
      this.datatoolsLiteService.triggerMessage$.next(DataToolsLiteMessage.DUPLIKIT_CUSTOM_WEIGHT);
      this.selected = selected;
      return;
    }

    this.weightService.hasChanged[this.reference.entity] = true;
    this.weightService.needsResync[this.reference.entity] = true;
    this.weightService.weightsChanged.next(true);
    this.dataToolsSettingsService.syncRequired.next(this.reference.entity);
    this.weightService.customWeightSelection[this.reference.entity][this.reference.weightField] = this.selected;
  }
}
